export default __webpack_public_path__ + "static/media/Rectangle 14.d78b2ed6.png";